import { t } from "@lingui/core/macro";
import React, {Component} from 'react'
import Meta from "../Meta"
import Header from "../components/Header"
import Footer from "../components/Footer"
import AccountSpace from "../../../components/AccountSpace"

// Wrapper thème Travel : habille le composant partagé AccountSpace avec le
// Header/Footer Travel + la classe .travel-page (CSS custom properties du thème).
export default class AccountSpacePage extends Component {
    render() {
        const context = this.props.context
        return (
            <div className="travel-page">
                <Meta context={context} title={t`Mon espace`}/>
                <Header context={context}/>
                {/* marginTop : aère sous le header (pattern CustomPage Travel). */}
                <div style={{minHeight: "70vh", marginTop: 32}}>
                    <AccountSpace context={context}/>
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}
